var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-detail-map"},[_c('div',{ref:"container",staticClass:"offer-detail-map__canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }